import { BrowserRouter as Router } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';
import Routing from "./routes/index";
import PageMeta from './components/Global/PageMeta';
import HashScroll from './components/Global/HashScroll';
import PostHogPageView from './components/Global/PostHogPageView';
import { StoreNotifyProvider } from './components/Global/StoreNotifyContext';
import { posthog, isPostHogConfigured } from './lib/posthog';
import './assets/css/icofont.min.css';
import './assets/css/owl.carousel.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/aos.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/legal.css';
import './assets/css/changelog.css';

function App() {
  const appTree = (
    <Router>
      <StoreNotifyProvider>
        <PageMeta />
        <HashScroll />
        {isPostHogConfigured ? <PostHogPageView /> : null}
        <Routing />
      </StoreNotifyProvider>
    </Router>
  );

  if (!isPostHogConfigured) {
    return appTree;
  }

  return (
    <PostHogProvider client={posthog}>
      {appTree}
    </PostHogProvider>
  );
}

export default App;
